import React, { useState, useEffect } from 'react';
import { useTranslate } from '../lib/i18n';
import { MessageDisplay } from './MessageDisplay';

interface Props {
  time: number | string; // TODO: Why do we allow both numbers and strings?
  content: string;
  displayHeader: boolean;
}

const UserMessage = ({ time, content, displayHeader }: Props) => {
  const [convertedTime, setConvertedTime] = useState('');
  const t = useTranslate();

  useEffect(() => {
    if (!time) return;
    // Parse the input date string
    const date = new Date(time);

    // Get hours and minutes in local time
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // Return the formatted time
    setConvertedTime(`${hours}:${minutes}`);
  }, [time]);

  return (
    <div className="mt-2 flex justify-end text-card-foreground">
      <div className="max-w-[80%] animate-slide-up flex flex-col items-end">
        {displayHeader && (
          <div className="mb-2 w-full flex items-center justify-between text-xs">
            <span>{t('userMessage.me')}</span>
            <span>{convertedTime}</span>
          </div>
        )}
        <div className="w-full rounded-md rounded-tr-none bg-secondary border px-4 py-2 text-left text-sm text-secondary-foreground">
          <div className="overflow-wrap-anywhere whitespace-pre-wrap break-words">
            {content && <MessageDisplay text={content} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserMessage;
